import { NetworkError } from './NetworkError.ts';

export class NoNetworkError extends NetworkError {
	/**
	 * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
	 * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
	 */
	ignore?: boolean;
}
